import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@scotia/canvas-react';
import { Alignment } from '@cldf/scotiaweb-canvas-react';
import { IconPointsVertical } from '../../../../../assets/IconPointsVertical';
import styles from './CardContext.scss';

export const CardContext = props => (
  <Card className={styles['card-padding']} flat>
    <div>
      <div className={styles['div---content']}>{props.children}</div>
      <div className={styles['div--menu-context']}>
        {props.menuContext && (
          <Alignment xs={'right'} md={'right'} lg={'right'} sm={'right'}>
            <IconPointsVertical />
          </Alignment>
        )}
      </div>
    </div>
  </Card>
);

CardContext.propTypes = {
  children: PropTypes.node.isRequired
};
